// ABOUTME: Composite Rusada TechLog number formatting for TechLog → Rusada paths.
export function formatRusadaTechLogTimestamp(
  dateTime: string | null | undefined,
): string {
  if (!dateTime) {
    return '';
  }
  const d = new Date(dateTime);
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  const y = d.getUTCFullYear();
  const mo = String(d.getUTCMonth() + 1).padStart(2, '0');
  const da = String(d.getUTCDate()).padStart(2, '0');
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mi = String(d.getUTCMinutes()).padStart(2, '0');
  return `${y}-${mo}-${da}T${hh}${mi}Z`;
}

type RusadaTechLogNoParams = {
  tripNumber: number | null | undefined;
  entityId: string | undefined;
  alternateTripId?: string | undefined;
  instantPrefix: string;
  middleParts: string[];
};

export function formatRusadaTechLogNo({
  tripNumber,
  entityId,
  alternateTripId,
  instantPrefix,
  middleParts,
}: RusadaTechLogNoParams): string {
  if (tripNumber === undefined || tripNumber === null) {
    return entityId || alternateTripId || `${instantPrefix}-${Date.now()}`;
  }

  const shortEntityId = entityId ? entityId.slice(0, 6) : '';
  const middle = middleParts.filter(Boolean).join('-');
  if (middle) {
    return `${tripNumber}/${middle}/${shortEntityId}`;
  }
  return `${tripNumber}/${shortEntityId}`;
}
